import useMapContext from 'components/Map/hooks/useMapContext';

import type { Feature, Position } from './types';

const useTextBox = () => {
    const { markers } = useMapContext();
    const { removeMarkerByFeatureId, updateMarker } = markers;

    const removeTextBox = (featureId: string) => {
        removeMarkerByFeatureId(featureId);
    };

    const upsertTextBox = (
        feature: Feature,
        position: Position,
        text: string,
        rotation?: number,
        isInteractive?: boolean
    ) => {
        updateMarker({
            feature: feature,
            isInteractive,
            position: position,
            rotation: rotation,
            text: text
        });
    };

    return {
        removeTextBox,
        upsertTextBox
    };
};

export default useTextBox;
